import TodayRecommend from '../views/cinemaManagement/todayRecommend'
import MoveList from '../views/cinemaManagement/movieList'
import ActressList from '../views/cinemaManagement/actressList'
import ChannelsManagement from '../views/cinemaManagement/channelsManagement'
import WatchHistory from '../views/cinemaManagement/watchHistory'
import FavoriteHistory from '../views/cinemaManagement/favoriteHistory'
import RecommendedList from '../views/cinemaManagement/recommendedList'
import ActressCollection from '../views/cinemaManagement/actressCollection'
import ActressRating from '../views/cinemaManagement/actressRating'

import Main from '../views/main'

const CinemaRouter = {
  path: '/today-recommend',
  component: Main,
  title: '影院管理',
  icon: 'el-icon-video-camera',
  meta: { keepAlive: true },
  children: [
    {
      path: '/today-recommend',
      component: TodayRecommend,
      name: 'todayRecommend',
      title: '今日推荐',
      meta: { title: '今日推荐'  ,keepAlive:true}
    },
    {
      path: '/move-list',
      component: MoveList,
      name: 'moveList',
      title: '影片列表',
      meta: { title: '影片列表' ,keepAlive:true}
    },
    {
      path: '/actress-list',
      component: ActressList,
      name: 'actressList',
      title: '女优列表',
      meta: { title: '女优列表' ,keepAlive:true}
    },
    {
      path: '/channels-management',
      component: ChannelsManagement,
      name: 'channelsmanagement',
      title: '频道管理',
      meta: { title: '频道管理' ,keepAlive:true}
    },
    {
      path: '/watch-history',
      component: WatchHistory,
      name: 'watchHistory',
      title: '影片观看记录',
      meta: { title: '影片观看记录' ,keepAlive:true}
    },
    {
      path: '/favorite-history',
      component: FavoriteHistory,
      name: 'favoriteHistory',
      title: '影片收藏记录',
      meta: { title: '影片收藏记录' ,keepAlive:true}
    },
    {
      path: '/recommended-list',
      component: RecommendedList,
      name: 'recommendedList',
      title: '影片推荐列表',
      meta: { title: '影片推荐列表' ,keepAlive:true}
    },
    {
      path: '/actress-collection',
      component: ActressCollection,
      name: 'actressCollection',
      title: '女优收藏记录',
      meta: { title: '女优收藏记录' ,keepAlive:true}
    },
    {
      path: '/actress-rating',
      component: ActressRating,
      name: 'actressRating',
      title: '女优评分记录',
      meta: { title: '女优评分记录' ,keepAlive:true}
    },
  ]
}
export default CinemaRouter